import { ProductUpdatePage } from '@/features/product/pages/ProductUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_item.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductUpdatePage,
})
